export const PricingConditionParamPluginSettings: IPluginSettings = {
    name: 'Параметр',
    mnemocode: 'pricing_condition_param_plugin',
    permission: 'Pricing',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'idGlobal',
            visibility: false,
            width: 150
        },
        {
            order: 1,
            propertyName: 'name',
            propertyType: 'string',
            displayName: 'Параметр',
            visibility: true,
            width: 300
        },
    ],
}